export default "__VITE_ASSET__DyvM0MLN__"